class MCProductStickyMedia extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enabled !== 'true' || this.observer) return;
    this.row = this.closest('.hdt-main-product-wrap');
    const content = this.row?.querySelector('.hdt-group-product-block');
    if (!content || this.parentElement !== this.row) return;
    this.contentColumn = content;
    while (this.contentColumn.parentElement !== this.row) {
      this.contentColumn = this.contentColumn.parentElement;
    }
    this.header = document.querySelector('.hdt-section-header');
    this.abortController = new AbortController();
    this.schedule = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateSticky();
      });
    };
    this.contentColumn.setAttribute('data-mc-sticky-column', '');
    this.row.dataset.mcCoordinatedSticky = 'none';
    this.observer = new ResizeObserver(this.schedule);
    [this, this.contentColumn, content, this.header].filter(Boolean)
      .forEach((element) => this.observer.observe(element));
    window.addEventListener('resize', this.schedule, { signal: this.abortController.signal });
    this.schedule();
  }

  updateSticky() {
    if (!this.isConnected) return;
    const media = this.getBoundingClientRect();
    const content = this.contentColumn.getBoundingClientRect();
    const top = (this.header?.getBoundingClientRect().height || 0) + Number(this.dataset.offset || 0);
    const available = window.innerHeight - top - Number(this.dataset.offset || 0);
    const sideBySide = media.right <= content.left + 2 || content.right <= media.left + 2;
    let target = 'none';
    if (window.matchMedia('(min-width: 768px)').matches && sideBySide) {
      if (media.height > 0 && media.height + 4 < content.height && media.height <= available) target = 'media';
      else if (content.height > 0 && content.height + 4 < media.height && content.height <= available) target = 'content';
    }
    this.row.style.setProperty('--mc-product-sticky-top', `${top}px`);
    if (this.row.dataset.mcCoordinatedSticky !== target) this.row.dataset.mcCoordinatedSticky = target;
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    this.abortController?.abort();
    cancelAnimationFrame(this.frame);
    this.frame = null;
    this.contentColumn?.removeAttribute('data-mc-sticky-column');
    if (this.row) {
      delete this.row.dataset.mcCoordinatedSticky;
      this.row.style.removeProperty('--mc-product-sticky-top');
    }
  }
}

if (!customElements.get('mc-product-sticky-media')) {
  customElements.define('mc-product-sticky-media', MCProductStickyMedia);
}
